export enum MetaOAuthErrors {
  INITIATE_FAILED = 'Unable to start the Meta Instagram connection.',
  STATUS_FAILED = 'Unable to load the Meta Instagram connection status.',
  DISCONNECT_FAILED = 'Unable to disconnect the Meta Instagram connection.',
  INVALID_RESPONSE = 'The Meta Instagram response was invalid.',
}
